var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      [
        _c(
          "v-row",
          { attrs: { dense: "" } },
          [
            _c("v-col", { attrs: { cols: "6", sm: "2" } }, [
              _c("h3", [_vm._v("Quick Look")]),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "Horizon: " +
                    _vm._s(_vm.horizon) +
                    " " +
                    _vm._s(_vm.plur("year", _vm.horizon))
                ),
              ]),
              _vm.date
                ? _c("p", { staticClass: "text-caption" }, [
                    _vm._v(_vm._s(_vm.date)),
                  ])
                : _vm._e(),
            ]),
            _c("v-spacer"),
            _c(
              "v-col",
              { attrs: { cols: "6", sm: "2" } },
              [
                _c("v-select", {
                  attrs: {
                    dense: "",
                    items: _vm.simulationYearArray,
                    "item-text": "text",
                    "item-value": "value",
                    outlined: "",
                    label: "Select Year",
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.selectedYear,
                    callback: function ($$v) {
                      _vm.selectedYear = $$v
                    },
                    expression: "selectedYear",
                  },
                }),
              ],
              1
            ),
            _vm.selectedTab === "nodal"
              ? _c(
                  "v-col",
                  { attrs: { cols: "6", sm: "2" } },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        dense: "",
                        items: _vm.nodes,
                        "item-text": "name",
                        "item-value": "id",
                        outlined: "",
                        label: "Select Node",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.computedSelectedNodeId.nodeId,
                        callback: function ($$v) {
                          _vm.$set(_vm.computedSelectedNodeId, "nodeId", $$v)
                        },
                        expression: "computedSelectedNodeId.nodeId",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "v-row",
          { attrs: { dense: "" } },
          [
            _vm.firstYearTable
              ? _c(
                  "v-col",
                  { attrs: { sm: "12", md: "4" } },
                  [_c("TableSimple", { attrs: { data: _vm.firstYearTable } })],
                  1
                )
              : _vm._e(),
            _vm.lastYearTable
              ? _c(
                  "v-col",
                  { attrs: { sm: "12", md: "4" } },
                  [_c("TableSimple", { attrs: { data: _vm.lastYearTable } })],
                  1
                )
              : _vm._e(),
            _vm.selectedYearTable
              ? _c(
                  "v-col",
                  { attrs: { sm: "12", md: "4" } },
                  [
                    _c("TableSimple", {
                      attrs: { data: _vm.selectedYearTable },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }